import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import HeroSection from '../components/public/HeroSection';
import AboutSection from '../components/public/AboutSection';
import VisionMissionSection from '../components/public/VisionMissionSection';
import { scrollToElement } from '../utils/helpers';

const HomePage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.substring(1);
      // Small timeout to ensure components are rendered
      setTimeout(() => {
        scrollToElement(elementId);
      }, 100);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <VisionMissionSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;